import { TrustAsHtmlFilterModule } from '@b2b/common/filters';
import { input } from '@b2b/types/core';
import angular from 'angular';

class TenantPolicyTermsController {
  policyText = input.required('');
}

export const TenantPolicyTermsComponentModule = angular
  .module('acme.common.component.tenant-policy-terms', [TrustAsHtmlFilterModule])
  .component('acmeTenantPolicyTerms', {
    templateUrl: 'common/components/tenant-policy-terms/tenant-policy-terms.component.tpl.html',
    controller: TenantPolicyTermsController,
    bindings: {
      policyText: '<',
    },
  }).name;
